var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('sub-visual', {
    attrs: {
      "sh": "About IST",
      "tabActive": "Certification Status",
      "bg": "/images/sub/visual/sv1.png"
    }
  }), _c('section', {
    staticClass: "sub-section sub-section--first"
  }, [_c('v-container', [_c('h2', {
    staticClass: "page-tit"
  }, [_vm._v(" Certification Status ")])]), _c('top-image', {
    attrs: {
      "src": "/images/sub/about/status/status-img.png"
    }
  })], 1), _c('section', {
    staticClass: "sub-section"
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit--md font-weight-bold line-height-1 mb-28 mb-lg-40"
  }, [_vm._v(" 인증 취득 현황 ")]), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('certification', {
    attrs: {
      "num": "품질경영 시스템",
      "src": "/images/sub/about/status/cert2-1.png"
    }
  }, [_vm._v(" ISO 9001:2015 ")]), _c('certification', {
    attrs: {
      "num": "환경경영 시스템",
      "src": "/images/sub/about/status/cert2-2.png"
    }
  }, [_vm._v(" ISO 14001:2015 ")]), _c('certification', {
    attrs: {
      "num": "정보보안경영 시스템",
      "src": "/images/sub/about/status/cert2-3.png"
    }
  }, [_vm._v(" ISO 27001 : 2013 ")]), _c('certification', {
    attrs: {
      "num": "안전보건경영 시스템",
      "src": "/images/sub/about/status/cert2-4.png"
    }
  }, [_vm._v(" ISO 45001:2018 ")])], 1)], 1)], 1), _c('section', {
    staticClass: "sub-section sub-section--last"
  }, [_c('v-container', [_c('h4', {
    staticClass: "tit--md font-weight-bold line-height-1 mb-28 mb-lg-40"
  }, [_vm._v(" 특허 취득 현황 ")]), _c('v-row', {
    staticClass: "my-n10 my-lg-n40"
  }, [_c('certification', {
    attrs: {
      "num": "특허 제 10-0879086 호",
      "src": "/images/sub/about/status/cert1-1.png"
    }
  }, [_vm._v(" 웨이퍼 연마용 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 리테이너 링 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-1123870 호",
      "src": "/images/sub/about/status/cert1-2.png"
    }
  }, [_vm._v(" 웨이퍼 연마용 리테이너 링 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 제조방법 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-1364089 호",
      "src": "/images/sub/about/status/cert1-3.png"
    }
  }, [_vm._v(" 웨이퍼 연마용 리테이너 링 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 및 그 제조방법 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-2246289 호",
      "src": "/images/sub/about/status/cert1-4.png"
    }
  }, [_vm._v(" 재사용이 가능한 웨이퍼 연마용 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 리테이너 링 및 그 제조방법 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-0879085 호",
      "src": "/images/sub/about/status/cert1-5.png"
    }
  }, [_vm._v(" 웨이퍼 연마용 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 리테이너 링 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-0884236 호",
      "src": "/images/sub/about/status/cert1-6.png"
    }
  }, [_vm._v(" 웨이퍼 연마용 "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 리테이너 링 ")]), _c('certification', {
    attrs: {
      "num": "특허 제 10-2247867 호",
      "src": "/images/sub/about/status/cert1-7.png"
    }
  }, [_vm._v(" 마찰 용접을 이용한 리테이너 링, "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v(" 그 제조 장치 및 방법 ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }